<template>
  <el-row class="ta-header">
    <div class="ta-chart-header">
      {{$t('charts.staticStresses.title')}}
    </div>
    <div :id="id"/>
  </el-row>
</template>

<script>
import Highcharts from 'highcharts'

export default {
  name: 'StaticStressLines',
  props: {
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      numberOfBlades: 2
    }
  },
  watch: {
    data () {
      if (this.data.stressMap) {
        this.rerender()
      }
    }
  },
  methods: {
    rerender () {
      Highcharts.chart(this.id, {
        chart: {
          type: 'line',
          backgroundColor: '#F1F6E4'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.getLabels(),
          title: {
            text: this.$t('charts.staticStresses.xAxis')
          }
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        series: this.getSeries()
      })
    },
    getLabels () {
      const labels = []
      this.iterate(0, (prop) => labels.push(prop))
      return labels
    },
    getSeries () {
      const series = []
      for (let i = 0; i < this.numberOfBlades; i++) {
        const values = []
        this.iterate(i, (prop, value) => values.push(value))
        series.push({
          name: this.$t('charts.labels.blades.label') + ' ' + (i + 1),
          data: values.map(s => s.staticStress)
        })
      }
      return series
    },
    iterate (bladeNumber, callback) {
      const stress = this.data.stressMap.blades[bladeNumber].stressMap
      for (const prop in stress) {
        if (Object.prototype.hasOwnProperty.call(stress, prop)) {
          callback(prop, stress[prop])
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
